import {ElMessage} from "element-plus";

export const copyText = (text) => {
    const textarea = document.createElement('textarea');
    // 设置相关属性
    textarea.readOnly = 'readonly';
    textarea.style.position = 'fixed';
    textarea.style.top = '-99999px';
    // 把目标内容赋值给它的value属性
    textarea.value = text;
    // 插入到页面
    document.body.appendChild(textarea);
    // 调用onselect()方法
    textarea.select();
    const res = document.execCommand('Copy');
    document.body.removeChild(textarea);
    ElMessage({
        type: res ? "success" : "error",
        message: res ? "复制成功" : "复制失败"
    })
}

export const gotoUrl = (name) => {
    window.location.href = name;
}
